import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/Add';
import AltaPercepcion from './AltaPercepcion';
import { useSnackbar } from 'notistack';
import AltaDeduccion from './AltaDeduccion';
import AltaIncidencias from './AltaIncidencias';
import AltaMovimiento from './AltaMovimiento';
import { obtenerincidenciasxlotes } from '../../../../Redux/LotesDucks';
import { useDispatch } from 'react-redux'

function TabPanel(props) {
    const { children, value, index, ...other } = props;




    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function ContenedorincidenciasAltas(props) {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();

    const [value, setValue] = React.useState(0);
    const { lote } = props
    const { periodo } = props
    const { idempleado } = props
    const { activarbotontab } = props
    
    const { empleadodepta } = props
    const { datotodoempleado } = props

    const obtenerdatolote = (consulta) => {
        dispatch(obtenerincidenciasxlotes(consulta))
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleClicknotificacion = (resultado) => {
        const variant = resultado.variant
        const msg = resultado.errores || resultado.msg
        // variant could be success, error, warning, info, or default
        enqueueSnackbar(msg, { variant });
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="icon tabs example"
                    textColor="primary"
                    indicatorColor="primary"
                >
                    <Tab icon={<AddIcon color="success" />} disabled={activarbotontab} iconPosition="start" label="Percepcion"  {...a11yProps(0)} />
                    <Tab icon={<AddIcon color="success" />} disabled={activarbotontab} iconPosition="start" label="Deduccion" {...a11yProps(1)} />
                    <Tab icon={<AddIcon color="success" />} disabled={activarbotontab} iconPosition="start" label="Incidencias" {...a11yProps(2)} />
                    <Tab icon={<AddIcon color="success" />} disabled={activarbotontab} iconPosition="start" label="Movimientos" {...a11yProps(2)} />
                </Tabs>
            </Box>

            <TabPanel value={value} index={0}>
                {activarbotontab === false ? (
                    <AltaPercepcion
                        lote={lote}
                        idempleado={idempleado}
                        periodo={periodo}
                        notificacion={handleClicknotificacion}
                        datotodoempleado={datotodoempleado}
                        obtenerdatolote={obtenerdatolote}
                    />
                ) : null}

            </TabPanel>
            <TabPanel value={value} index={1}>
                {activarbotontab === false ? (
                    <AltaDeduccion
                        lote={lote}
                        idempleado={idempleado}
                        periodo={periodo}
                        notificacion={handleClicknotificacion}
                        datotodoempleado={datotodoempleado}
                        obtenerdatolote={obtenerdatolote}
                    />
                ) : null}

            </TabPanel>
            <TabPanel value={value} index={2}>
                {activarbotontab === false ? (
                    <AltaIncidencias
                        lote={lote}
                        idempleado={idempleado}
                        periodo={periodo}
                        notificacion={handleClicknotificacion}
                        datotodoempleado={datotodoempleado}
                        obtenerdatolote={obtenerdatolote}
                    />
                ) : null}
            </TabPanel>
            <TabPanel value={value} index={3}>
                {activarbotontab === false ? (
                    <AltaMovimiento
                        lote={lote}
                        idempleado={idempleado}
                        empleadodepta={empleadodepta}
                        periodo={periodo}
                        notificacion={handleClicknotificacion}
                        datotodoempleado={datotodoempleado}
                        obtenerdatolote={obtenerdatolote}
                    />
                ) : null}
            </TabPanel>
        </Box>
    );
}